import { z } from 'zod';
import { UserSchema, UserTypeSchema, UserClassificationSchema, refineExternalMember } from '../../../../entities/user/user.schema';
import { ErrorCode } from '../../../../shared/error-codes';
/**
 * Update Tenant User Request Schema
 * PATCH /api/v2/tenants/:tenantId/users/:userId
 */ export const UpdateTenantUserRequestSchema = z.object({
    firstName: z.string().min(1, ErrorCode.FIELD_REQUIRED).optional(),
    lastName: z.string().min(1, ErrorCode.FIELD_REQUIRED).optional(),
    email: z.string().email(ErrorCode.FIELD_INVALID_EMAIL).optional(),
    userTypes: z.array(UserTypeSchema).optional(),
    classification: UserClassificationSchema.optional(),
    externalOrganization: z.string().optional(),
    homeOrgTenantId: z.string().optional()
}).superRefine((data, ctx)=>{
    // External members: externalOrganization required, plus the role rule when
    // userTypes is in the payload. Partial PATCH (userTypes omitted) is judged
    // authoritatively by the update-tenant-user service against the stored doc.
    refineExternalMember(ctx, data, {
        partial: true
    });
});
/**
 * Update Tenant User Response Schema
 */ export const UpdateTenantUserResponseSchema = z.object({
    data: UserSchema
});

//# sourceMappingURL=update-tenant-user.schema.js.map